import { get, post } from '../../services/api';
import { useEffect, useState } from 'react';
import { format, isAfter, subMonths } from 'date-fns';

import './FiltrosPontuacaoGeral.css'

export default function FiltrosPontuacaoGeral({ filtros, setFiltros, resetPage, resetRuntimeFilter, getPontuacao }) {
    const [ filtrosInput, setFiltrosInput ] = useState(filtros);
    
    const [regioes, setRegioes] = useState([[]]);
    const [filiais, setFiliais] = useState([[]]);
    const [tiposPontuacao, setTiposPontuacao] = useState([[]]);
    const tiposVariante = [
        { id_variante_pontuacao: 1, descricao: 'Funcionario' },
        { id_variante_pontuacao: 2, descricao: 'Filial' }
    ];
    const [carregando, setCarregando] = useState(true);

    const primeiroPeriodo = new Date(2023, 10, 1);
    const dataAtual = new Date;
    let periodos = [];

    for (let i = 0; i <= 11; i++) {
        if (isAfter(subMonths(dataAtual, i), primeiroPeriodo)) {
            periodos.push(format(subMonths(dataAtual, i), 'MM/yyyy'));
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFiltrosInput((prevFiltros) => ({ ...prevFiltros, [name]: value }));
    };

    const buscarRegioes = async () => {
        setCarregando(true);
        const resRegioes = await post('/vendedores/regioes', { idFilial: 0 });
        setRegioes(resRegioes);
        setCarregando(false);
    }

    const buscarFiliais = async () => {
        setCarregando(true);
        const resFiliais = await post('/vendedores/filiais', { idRegiao: filtrosInput.regiao });
        setFiliais(resFiliais);
        setCarregando(false);
    }

    const buscarTiposPontuacao = async () => {
        const authToken = localStorage.getItem('adminToken')

        setCarregando(true);
        const resTipos = await get('/admin/pontuacaogeral/tipos', null, authToken)
        setTiposPontuacao([ { id_tipo_pontuacao: 0, descricao: 'Todos' }, ... resTipos ]);
        setCarregando(false);
    }

    const carregar = () => {
        resetPage()
        resetRuntimeFilter()
        setFiltros(filtrosInput)
        getPontuacao(
            filtrosInput.periodo.split('/')[0],
            filtrosInput.periodo.split('/')[1],
            filtrosInput.regiao,
            filtrosInput.filial,
            filtrosInput.tipo_pontuacao,
            filtrosInput.variante_pontuacao,
            1,
            '',
            ''
        );
    }

    useEffect(() => {
        buscarRegioes();
        buscarTiposPontuacao();
    }, []);

    useEffect(() => {
        setFiltrosInput((prevFiltros) => ({ ...prevFiltros, filial: 0 }));
        buscarFiliais();
    }, [filtrosInput.regiao]);

    return (
        <div className='pontuacao-geral-first'>
            <div className='header'>
                <span>1</span>
                <h1>Selecione os filtros</h1>
            </div>

            <div className='body'>
                <div className='periodo-wrapper'>
                    <label htmlFor="periodo">Período</label>
                    <select name="periodo" id="periodo" value={filtrosInput.periodo} onChange={handleChange}>
                        {periodos && periodos.length > 0 && periodos.map((p, i) => (
                            <option key={i} value={p}>{p}</option>
                        ))}
                    </select>
                </div>
                <div className='regiao-wrapper'>
                    <label htmlFor="regiao">Região</label>
                    <select name="regiao" id="regiao" value={filtrosInput.regiao} onChange={handleChange}>
                        <option value="0">Todas</option>
                        {regioes && regioes.length > 0 && regioes.map((r, i) => (
                            <option key={i} value={r.id_regiao}>{r.nome_regiao}</option>
                        ))};
                    </select>
                </div>
                <div className='filial-wrapper'>
                    <label htmlFor="filial">Filial</label>
                    <select name="filial" id="filial" value={filtrosInput.filial} onChange={handleChange}>
                        <option value="0">Todas</option>
                        {filiais && filiais.length > 0 && filiais.map((f, i) => (
                            <option key={i} value={f.cod_sabium}>{f.cod_sabium - 10000} - {f.nome}</option>
                        ))};
                    </select>
                </div>
                <div className='variante-pontuacao-wrapper'>
                    <label htmlFor="variante_pontuacao">Mostrar por</label>
                    <select name="variante_pontuacao" id="variante_pontuacao" value={filtrosInput.variante_pontuacao} onChange={handleChange}>
                        {tiposVariante.map((variante, i) => (
                            <option key={i} value={variante.id_variante_pontuacao}>{variante.descricao}</option>
                        ))};
                    </select>
                </div>
                {filtrosInput.variante_pontuacao == '1' &&
                    <div className='tipo-pontuacao-wrapper'>
                        <label htmlFor="tipo_pontuacao">Tipo</label>
                        <select name="tipo_pontuacao" id="tipo_pontuacao" value={filtrosInput.tipo_pontuacao} onChange={handleChange}>
                            {tiposPontuacao && tiposPontuacao.length > 0 && tiposPontuacao.map((tipo, i) => (
                                <option key={i} value={tipo.id_tipo_pontuacao}>{tipo.descricao}</option>
                            ))};
                        </select>
                    </div>
                }
                <button className='primary-btn' disabled={carregando} onClick={carregar}>Carregar</button>
            </div>
        </div>
    );
}
